import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAPI from "../api/hooks/useAPI";
import { useOnboarding } from "../contexts/OnboardingContext";
import { ONBOARDING_STEPS } from "../utils/constants";

const useOnboardingAutoOpen = () => {
  const { currentStage, openOnboardingModal } = useOnboarding();
  const { trackEvent } = useAPI();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      currentStage === ONBOARDING_STEPS.WELCOME ||
      currentStage === ONBOARDING_STEPS.LEARN_BASICS
    ) {
      trackEvent(
        currentStage === ONBOARDING_STEPS.WELCOME
          ? "Auto-opening onboarding modal for new user"
          : "Auto-opening onboarding modal for learn basics"
      );
      openOnboardingModal();
    }
    if (currentStage === ONBOARDING_STEPS.LEARN_BASICS) {
      trackEvent("Auto-opening onboarding modal for learn basics");
      if (!location.pathname.includes("onboarding")) {
        navigate("/onboarding/posture/controls");
      }
      openOnboardingModal();
    }
  }, [currentStage, openOnboardingModal]);
};

export default useOnboardingAutoOpen;
